import { AddInscriptionModalTitles } from 'routes/BudgetModule/components/shared/InscriptionsGrid/AddInscription/types';
import { SecondaryBudgetAxisSources } from 'routes/Support/components/ClientSupport/components/BudgetConfiguration/types';
import { getClientBind } from 'store/APIClient';

export const getAddInscriptionStepTitles = (
    t: TranslationT,
    resourceName: string,
    operationName: string,
    sourceTable: SecondaryBudgetAxisSources | null,
): AddInscriptionModalTitles => {
    const resourceNameLower = resourceName.toLowerCase();
    const bind = getClientBind();
    return {
        budgetProposalSelection: {
            title: t('addInscriptionModal.budgetProposalSelectionTitle', {
                dimension: `${resourceNameLower}`,
            }),
            subTitle: t(
                'secondaryBudgetAxisElement360.budgetProposalSelectionSubtitle',
                {
                    dimension: `${resourceNameLower}`,
                    gender: bind === 'ampmetropole' ? 'auxquelles' : 'auxquels',
                    context: sourceTable,
                },
            ),
        },
        budgetLineSelection: {
            title: t('addInscriptionModal.budgetLineSelectionTitle'),
            subTitle: t(
                'secondaryBudgetAxisElement360.budgetLineSelectionSubtitle',
                {
                    dimension: `${resourceNameLower}`,
                    secondaryBudgetAxisElementName: `${operationName}`,
                    context: sourceTable,
                },
            ),
        },
    };
};
